export const GET_ALL_HOUSES = 'GET_ALL_HOUSES';
export const CLEAR_QUERY = 'CLEAR_QUERY';
